import { render, staticRenderFns } from "./AdherenceCategory.vue?vue&type=template&id=452770ed&"
import script from "./AdherenceCategory.vue?vue&type=script&lang=js&"
export * from "./AdherenceCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports